module.exports = __webpack_public_path__ + "static/media/img_stellar_ktc.660c89f8.png";